module.exports = __webpack_public_path__ + "static/media/about-light.8cd8f24d.a675145b.svg";